import React from 'react';
import i18n from '@shared/i18n';
import { type BuyerLayoutProps } from 'shop-ui/types';
import { getDisplayPrice } from 'app/libs/getDisplayPrice';

interface ProductPriceProps extends BuyerLayoutProps<Product> {}

export const ProductPrice: React.FC<ProductPriceProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const { price, promo_saving_price, discounted_price } = product;

    const chooseSpecDetail = product.spec_details[0];

    const ssrPrice = chooseSpecDetail
        ? getDisplayPrice({
              originalPrice: chooseSpecDetail.price,
              discountedPrice: chooseSpecDetail.discounted_price,
              promoSavingPrice: chooseSpecDetail.promo_saving_price,
              minAddOnPrice: null,
          })
        : getDisplayPrice({
              originalPrice: price,
              discountedPrice: discounted_price,
              promoSavingPrice: promo_saving_price,
              minAddOnPrice: null,
          });

    return (
        <div>
            {ssrPrice.useDiscountedPrice && ssrPrice.discountedPrice && (
                <div className="skeleton skeleton--ssr skeleton--sm">
                    <span className="ssr-hidden">{ssrPrice.discountedPrice.value}</span>
                </div>
            )}
            <div className="skeleton-spacer"></div>
            <span className="skeleton skeleton--ssr skeleton--sm">
                <b className="ssr-hidden">{ssrPrice.originalPrice?.value}</b>
            </span>
            <div className="skeleton-spacer"></div>
            {ssrPrice.promoSavingPrice && (
                <div className="skeleton skeleton--ssr skeleton--sm">
                    <span className="ssr-hidden">
                        {i18n.gettext('省下')} {ssrPrice.promoSavingPrice.value}
                    </span>
                </div>
            )}
        </div>
    );
};
